function hasId(element){
	return typeof element.id != 'undefined';
}
jQuery(document).ready(function($) {
	$('.post-carousel').slick({
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		centerMode: false,
		dots: false,
		arrows: true,
		responsive: [
			{
			  breakpoint: 767,
			  settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				centerMode: true,
				centerPadding: '70px',
			  }
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		  ]
	});
	
	
	
	$('.mobile-carousel').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: true,
		centerPadding: '70px',
		mobileFirst: true,
		responsive: [
		  {
				  breakpoint: 768,
				  settings: 'unslick'
		  }
		]
	});
	
	$('.banner-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: false,
		dots: true,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 6000,
		fade: true
	});
	
	$('.cta-banner-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: false,
		dots: true,
		arrows: false,
		autoplay: false,
	});
	
	$('.twitter-carousel').slick({
		infinite: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		centerMode: false,
		dots: false,
		arrows: true,
		responsive: [
			{
			  breakpoint: 767,
			  settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				centerMode: true,
				centerPadding: '20px',
			  }
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		  ]
	});
	$('.longform-post .carousel').slick({
		dots: false,
		arrows: true,
		infinite: false,
		autoplay: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		draggable: false,
		prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="22" viewBox="0 0 14 22"><g fill="none" fill-rule="evenodd"><g fill="#246EF3"><path d="M.298 20.49c-.397.345-.397.905 0 1.25.396.346 1.04.347 1.437 0L13.35 11.627c.397-.346.397-.906 0-1.252L1.735.259C1.338-.086.695-.086.298.26c-.397.346-.397.906 0 1.252l10.592 9.49L.298 20.488z" transform="matrix(-1 0 0 1 13.647 0)"/></g></g></svg></button>',
		nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="22" viewBox="0 0 14 22"><g fill="none" fill-rule="evenodd"><g fill="#246EF3"><path d="M.298 20.49c-.397.345-.397.905 0 1.25.396.346 1.04.347 1.437 0L13.35 11.627c.397-.346.397-.906 0-1.252L1.735.259C1.338-.086.695-.086.298.26c-.397.346-.397.906 0 1.252l10.592 9.49L.298 20.488z"/></g></g></svg></button>',
		responsive: [
			{
			  breakpoint: 768,
			  settings: {
				slidesToShow: 2
			  }
			},
			{
			  breakpoint: 600,
			  settings: {
				slidesToShow: 1,
			  }
			}
	
		  ]
	  });
	  
	  $('.longform-post .carousel-wide').slick({
		dots: false,
		arrows: true,
		infinite: true,
		autoplay: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: true,
		centerPadding: '10%',
		draggable: false,
		variableWidth: true,
		prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="22" viewBox="0 0 14 22"><g fill="none" fill-rule="evenodd"><g fill="#246EF3"><path d="M.298 20.49c-.397.345-.397.905 0 1.25.396.346 1.04.347 1.437 0L13.35 11.627c.397-.346.397-.906 0-1.252L1.735.259C1.338-.086.695-.086.298.26c-.397.346-.397.906 0 1.252l10.592 9.49L.298 20.488z" transform="matrix(-1 0 0 1 13.647 0)"/></g></g></svg></button>',
		nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="22" viewBox="0 0 14 22"><g fill="none" fill-rule="evenodd"><g fill="#246EF3"><path d="M.298 20.49c-.397.345-.397.905 0 1.25.396.346 1.04.347 1.437 0L13.35 11.627c.397-.346.397-.906 0-1.252L1.735.259C1.338-.086.695-.086.298.26c-.397.346-.397.906 0 1.252l10.592 9.49L.298 20.488z"/></g></g></svg></button>',
		responsive: [
			{
			  breakpoint: 1050,
			  settings: {
				variableWidth: false,
				adaptiveHeight: true,
				centerPadding: '0',
			  }
			},
		]
	  });
	  $('.module .carousel-wide').slick({
		  dots: false,
		  arrows: true,
		  infinite: true,
		  autoplay: false,
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  centerMode: true,
		  centerPadding: '10%',
		  draggable: false,
		  variableWidth: true,
		  prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="22" viewBox="0 0 14 22"><g fill="none" fill-rule="evenodd"><g fill="#246EF3"><path d="M.298 20.49c-.397.345-.397.905 0 1.25.396.346 1.04.347 1.437 0L13.35 11.627c.397-.346.397-.906 0-1.252L1.735.259C1.338-.086.695-.086.298.26c-.397.346-.397.906 0 1.252l10.592 9.49L.298 20.488z" transform="matrix(-1 0 0 1 13.647 0)"/></g></g></svg></button>',
		  nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="22" viewBox="0 0 14 22"><g fill="none" fill-rule="evenodd"><g fill="#246EF3"><path d="M.298 20.49c-.397.345-.397.905 0 1.25.396.346 1.04.347 1.437 0L13.35 11.627c.397-.346.397-.906 0-1.252L1.735.259C1.338-.086.695-.086.298.26c-.397.346-.397.906 0 1.252l10.592 9.49L.298 20.488z"/></g></g></svg></button>',
		  responsive: [
			  {
				breakpoint: 1050,
				settings: {
				  variableWidth: false,
				  adaptiveHeight: true,
				  centerPadding: '0',
				}
			  },
		  ]
		});
	var $formcarousel = $('.form-steps');
	
	var adaptive = false;
	if($formcarousel.hasClass('community-steps')) {
		adaptive = true;
	}
	$formcarousel.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: false,
		arrows: false,
		dots: false,
		fade: true,
		adaptiveHeight: adaptive,
		swipe: false,
		touchMove: false,
		responsive: [
			{
			  breakpoint: 767,
			  settings: {
				adaptiveHeight: true
			  }
			}
		]
	});
	
	$formcarousel.on('afterChange', function(slick, currentSlide){
		if(jQuery(window).width() < 1024) {
			jQuery('.signup-fod .form')[0].scrollIntoView({ behavior: "smooth"});
		}
	});
	
	if(sessionStorage.getItem("fod_signup") == 'success') {
		$formcarousel.not('.community-steps').slick('slickGoTo', 2);
		jQuery('.step3').addClass('show-success')
	}
	
	jQuery(document).on('click', '.form-steps .next-form', function(e) {
		e.preventDefault();
		var error_count = 0;
		
		var none_field = jQuery(this).parents('.form-steps').find('.slick-active #group_16384')[0];

		if (none_field && none_field.checked) {
			jQuery('.form-step .focus-error').addClass('visible');
			if (jQuery(window).width() < 1024) {
				jQuery(this).parents('.form')[0].scrollIntoView({ behavior: "smooth" });
			}
			error_count = error_count + 1;
		}
		jQuery(this).parents('.form-steps').find('.slick-active .required-fod').each(function(){
			var field = jQuery(this)[0];
			var element = mc_validate_element(field);
			
			if(element == false) {
				error_count = error_count +1;
			} 
		
		
		});
		
		if(jQuery(this).parents('.form-steps').find('.slick-active .checkbox-field-group').length) {
			jQuery(this).parents('.form-steps').find('.slick-active .checkbox-field-group:not(.optional)').each(function() {
				if(jQuery(this).find(':checkbox:checked').length == 0) {
				
					error_count = error_count + 1;
					jQuery(this).addClass('has-error');
				} else {
					jQuery(this).removeClass('has-error');
				}
			});
		}
		
		if(jQuery(this).parents('.form-steps').find('.slick-active .radio-field-group').length) {
			jQuery(this).parents('.form-steps').find('.slick-active .radio-field-group:not(.optional)').each(function() {
				if(jQuery(this).find(':radio:checked').length == 0) {
				
					error_count = error_count + 1;
					jQuery(this).addClass('has-error');
				} else {
					jQuery(this).removeClass('has-error');
				}
			});
		}
		
		
		
		if(error_count < 1) {
			jQuery(this).parents('.form-steps').slick("slickNext");
		}
	});
	
	jQuery(document).on('click', '.form-steps .prev-form', function(e) {
		e.preventDefault();
		if(jQuery(this).hasClass('clear-focus-error')) {
			jQuery('.form-step .focus-error').removeClass('visible'); 
		} else {
			jQuery(this).parents('.form-steps').slick("slickPrev");
		}
		
		
	});
	jQuery(document).on('click', '.form-steps .restart', function(e) {
		e.preventDefault();
		jQuery('.form-step.step3').removeClass('show-error');
		jQuery('.form-step.step3 .mc-status').empty();
		$formcarousel.slick('slickGoTo', 0);
	});
});